import { setAmplitudeExperiments } from '@/store/actions';
import { recordExperimentSource } from '@/utilities/logger/amplitude/experiments/experimentExposure';
import { AggregationData } from '../types';

export const dispatchExperiments = (
  experiments?: AggregationData['experiments'],
) => {
  if (!experiments || Object.keys(experiments).length === 0) {
    return;
  }

  recordExperimentSource(experiments, 'aggregation');
  setAmplitudeExperiments(experiments);
};
